import BenchlingConfig from 'BenchlingConfig';
import {StructuredTable, StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';

export function isStructuredTableShortcutDisabled({
  structuredTable,
  hasValidSourceColumns,
}: {
  structuredTable: StructuredTable<unknown, unknown>;
  hasValidSourceColumns: boolean;
}): boolean {
  const noFinalizedRows =
    structuredTable.kind !== StructuredTableKind.LOOKUP &&
    !structuredTable.rows.some((row) => row.isFinalized);
  if (noFinalizedRows) {
    return true;
  }
  if (!hasValidSourceColumns) {
    return true;
  }
  return false;
}

export function computeItemsShortcutDisabledState({
  itemsCount,
  disabledFlag,
}: {
  itemsCount: number;
  disabledFlag: boolean;
}): boolean {
  const overLimit = itemsCount > BenchlingConfig.WORKFLOWS_MAX_TASKS_PER_TASK_GROUP;
  return disabledFlag || itemsCount === 0 || overLimit;
}
